import { createFileRoute } from '@tanstack/react-router';
import UnderDevelopment from '@src/pages/UnderDevelopment';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/dashboard')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('dashboard.page_title', 'Dashboard') }],
  }),
  component: UnderDevelopment,
});
